import DropdownSelector from 'components/DropdownSelector';
import { nwsAlertTypes } from 'features/Weather/features/WeatherAlerts/config/nwsAlertTypes.config';
import { useEffect, useState } from 'react';

const FusionAlertCondition = ({ data, setData, setError, readOnly = false }) => {
  const [selectedAlertTypeIndex, setSelectedAlertTypeIndex] = useState(0);

  const handleSelectAlertType = (index) => {
    const nextAlertType = nwsAlertTypes[index];

    setData({
      ...data,
      selectedAlertType: nextAlertType || '',
      error: !nextAlertType,
    });

    setSelectedAlertTypeIndex(index);
  };

  useEffect(() => {
    if (!data?.selectedAlertType) {
      setError({ message: 'Please select an alert type.' });
    } else {
      setError(false);
    }
  }, [data?.selectedAlertType, setError]);

  return (
    <div className="d-flex flex-column w-100">
      <div className="global-action-builder-row d-flex flex-column p-3 rounded-2 m-2 align-items-stretch align-items-md-center">
        <label className="fs-6 mb-1 fw-medium w-100">Alert Types:</label>
        <DropdownSelector
          options={nwsAlertTypes}
          selectedOption={selectedAlertTypeIndex}
          setSelected={handleSelectAlertType}
          closeOnSelect={true}
          contentStyle={{ maxHeight: 280, overflowY: 'auto' }}
        />
      </div>
    </div>
  );
};

export default FusionAlertCondition;
